import PageLayout from "components/layout/PageLayout";
import { useLazyGetDevicesStatusQuery } from "./api/devicesStatusApiSlice";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import DeviceStats from "../views/DeviceStats";
import NoData from "components/commons/NoData";
import DeviceCard from "./view/DeviceCard";


function DeviceDashboard() {
    const [t] = useTranslation(["global", "device"])
    const { state: locationState } = useLocation()
    const highlightDeviceGuid = locationState?.highlightDeviceGuid ?? null

    const [autoRefresh, setAutoRefresh] = useState(true)
    const canManageDevices = true
    const refreshSeconds = 30

    const [getStatus, {
        data: devices,
        isFetching,
        isLoading,
        isSuccess,
        isError,
        error
    }] = useLazyGetDevicesStatusQuery()

    useEffect(() => {
        getStatus()
        if (autoRefresh) {
            const interval = setInterval(() => getStatus(), refreshSeconds * 1000)
            return () => clearInterval(interval)
        }
    }, [getStatus, autoRefresh])

    const content = (
        <>
            <div className="d-flex justify-content-end mb-3 form-check form-switch">
                <input
                    type="checkbox"
                    className="form-check-input"
                    checked={autoRefresh}
                    onChange={() => setAutoRefresh(!autoRefresh)}
                />
                <label className="form-check-label ms-2">
                    Auto-Refresh <span className="text-muted">{refreshSeconds}s</span>
                </label>
            </div>

            {isSuccess && (
                <div className="container mt-4">
                    {devices.length > 0 ? (
                        <>
                            <DeviceStats devices={devices} />
                            <table className="table table-dark table-hover align-middle">
                                <thead>
                                    <tr>
                                        <th scope="col">ID</th>
                                        <th scope="col">{t("device:entity.device.props.enabled")}</th>
                                        <th scope="col">IP</th>
                                        <th scope="col">{t("device:entity.device.props.model")}</th>
                                        <th scope="col">{t("device:entity.device.props.battery")}</th>
                                        <th scope="col">{t("device:entity.device.props.state")}</th>
                                        <th scope="col">{t("device:entity.device.props.info")}</th>
                                        <th scope="col">{t("device:entity.device.props.last_user")}</th>
                                        <th scope="col">{t("property.actions")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {devices.map((device) => (
                                        <DeviceCard
                                            key={device.guid}
                                            device={device}
                                            canManageDevices={canManageDevices}
                                            highlighted={device.guid === highlightDeviceGuid}
                                        />
                                    ))}
                                </tbody>
                            </table>
                        </>
                    ) : (
                        <NoData message={t("device:helper.no_devices")} />
                    )}
                </div>
            )}
        </>
    )

    return (
        <PageLayout
            pageTitle={t("device:menu.devices_manager")}
            bodyContent={content}
            isLoadingPage={isLoading}
            isLoadingContent={isFetching}
            isError={isError}
            errorMsg={error}
            onPageRefresh={getStatus}
        />
    )
}

export default DeviceDashboard;
